import {initializeMasonry} from "./masonry";

export function initializePagination() {
    if ($('.pagination').length > 0) {
        $('.pagination').each(function () {
            let self = $(this);
            $(this).on('click', '.page-link', function (e) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(this).closest('.block-container').offset().top
                });
                e.preventDefault();
                $('#loader-modal').addClass('visible');
                let page = 1;
                let listing = '';
                let search = '';
                try {
                    let url = $(this).attr('href');
                    page = $.urlParam(url, 'page');
                    listing = $.urlParam(url, 'listing');
                    search = $.urlParam(url, 'search');
                } catch (e) {}
                let url = self.closest('.block-container').data('action');
                $.ajax({
                    type: 'GET',
                    url: url,
                    async: true,
                    data: {page: page, listing: listing, search: search},
                    success: function (data) {
                        $(self).closest('.block-container').html(data.view)
                        initializeMasonry();
                        initializePagination();
                        initializeGalleryBlock();
                        $('#loader-modal').removeClass('visible');
                        return true;
                    }, error: function (data) {
                        return false;
                    }
                });
            });
        });
    }

    $.urlParam = function(url, name){
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(url);
        if (results==null) {
            return null;
        }
        return decodeURI(results[1]) || '';
    }
}
